import React, {Component} from "react";
import "./OrderItem.css"
import {FormattedMessage} from "react-intl";
import process from "../../../../../assets/img/process.png";
import ItemDetailsModal from "./ItemDetailsModal";
import OrderType1ExpandedView
    from "../../../Cart/CartItem/CartItemDetails/OrderType1ExpandedView/OrderType1ExpandedView";
import {Link} from "react-router-dom";
import {Modal} from "react-bootstrap";
import UserInquiryForm from "../../../UserInquiryForm/UserInquiryForm";
import QualityComplaints from "../QualityComplaints/QualityComplaints";
import axios from "axios";
import {RESOURCE_BASE_URL} from "../../../../../configuration";
import ReactImageZoom from "react-image-zoom";
import hunImg from '../../../../../assets/img/100img.png'
import {buildStyles, CircularProgressbar} from 'react-circular-progressbar';
import 'react-circular-progressbar/dist/styles.css';
import moment from "moment";
import ReorderComponent from "./ReorderComponent/ReorderComponent";
import progress from "../../../../../assets/img/progress-new.png";
import noProgress from "../../../../../assets/img/no-progress.png";
import testj from "../../../../../assets/img/slide-1-4.png";
import slide2 from "../../../../../assets/img/slide-2.jpg";
import slide3 from "../../../../../assets/img/slide-3.jpg";
import slide4 from "../../../../../assets/img/slider_img4.jpg";
import slide5 from "../../../../../assets/img/slider_img5.jpg";
import aoi from "../../../../../assets/video/productionProgress/AutomaticeAOI.mp4";
import copper from "../../../../../assets/video/productionProgress/CopperDeposition.mp4";
import drill from "../../../../../assets/video/productionProgress/DrilingThePCB.mp4";
import electricalTest from "../../../../../assets/video/productionProgress/ElectricalTest.mp4";
import finalInspection from "../../../../../assets/video/productionProgress/Finalinspection.mp4";
import hotAir from "../../../../../assets/video/productionProgress/HotAirsolderLeveling.mp4";
import imageOuter from "../../../../../assets/video/productionProgress/Image the outer layers.mp4";
import plating from "../../../../../assets/video/productionProgress/Plating.mp4";
import profiling from "../../../../../assets/video/productionProgress/Pofiling V-cut.mp4";
import silkScreen from "../../../../../assets/video/productionProgress/Silk Screen.mp4";
import solder from "../../../../../assets/video/productionProgress/Solder Mask.mp4";
import $ from "jquery";
import canvasDown from "../../../../../assets/img/canvasdown.png";
import canvasUp from "../../../../../assets/img/canvasup.png";

const dimensionValues = [
    {id: 112, value: "470×370（有効エリア290×190mm）"},
    {id: 111, value: "400×300（有効エリア240×140mm）"},
    {id: 111, value: "400×300（有効エリア240×140mm）"},
    {id: 3, value: "520×420（有効エリア340×240mm）"},
    {id: 6, value: "550×450（有効エリア370×270mm）"},
    {id: 7, value: "584×584（有効エリア380×380mm）"},
    {id: 5, value: "650×550（有効エリア450×350mm）"},
    {id: 124, value: "700×500（有効エリア500×320mm）"},
    {id: 108, value: "600×400（有効エリア400×220mm）"},
    {id: 8, value: "736×736（有効エリア500×500mm）"},
    {id: 3, value: "520×420（有効エリア340×240mm）"},
    {id: 109, value: "800×400（有効エリア600×220mm）"},
    {id: 119, value: "800×500（有効エリア600×320mm）"},
    {id: 110, value: "1000×400（有効エリア760×220mm）"},


    {id: 117, value: "380×280（有効エリア290×190mm)"},
    {id: 113, value: "420×320（有効エリア400×240mm"},
    {id: 114, value: "450×350（有効エリア420×270mm"},
    {id: 115, value: "520×420（有効エリア490×340mm"},
    {id: 116, value: "460×460（有効エリア430×380mm"},
];

const ImageView = (props) => {
    if (props.imagePath) {
        const imgProps = {
            "width": 120, "scale": 2.5, "img": props.imagePath, "offset": {"vertical": -100, "horizontal": 10},
            "border": "1px solid #ececec", "z-index": 5000000
        };
        return (
            <div className="cart-item-preview-image">
                <ReactImageZoom className="cart-item-preview-image" {...imgProps} />
            </div>
        );
    } else {
        return <span>X</span>
    }
};


class OrderItem extends Component {

    constructor(props) {
        super(props);
        this.state = {
            dimension3: '',
            size: 0,
            processList: [],
            wipProcessList: [],
            show: false,
            productionStatus: {},
            showProcess: false,
            showImage: false,
            bigImage: '',
            shipStatus: ''

        };

        this.getOrderProductionStatus = this.getOrderProductionStatus.bind(this);
        this.handleShowProcess = this.handleShowProcess.bind(this);
        this.handleCloseProcess = this.handleCloseProcess.bind(this);
        this.showImage = this.showImage.bind(this);
        this.showImage1 = this.showImage1.bind(this);
        this.hideImage = this.hideImage.bind(this);
    }

    showImage(processName) {
        this.setState({showImage: true},
            () => {
                if (processName === "MI") {
                    this.setState({bigImage: slide2})
                } else if (processName === "Inner Layer") {
                    this.setState({bigImage: slide3})
                } else if (processName === "Lamination") {
                    this.setState({bigImage: slide4})
                } else if (processName === "Drilling") {
                    this.setState({bigImage: drill})
                } else if (processName === "Copper Deposition") {
                    this.setState({bigImage: copper})
                } else if (processName === "Image the outer layers") {
                    this.setState({bigImage: imageOuter})
                } else if (processName === "pattern Plating") {
                    this.setState({bigImage: plating})
                } else if (processName === "Automatic Optical Inspection(AOI)") {
                    this.setState({bigImage: aoi})
                } else if (processName === "Solder Mask") {
                    this.setState({bigImage: solder})
                } else if (processName === "Silkscreen") {
                    this.setState({bigImage: silkScreen})
                } else if (processName === "HASL") {
                    this.setState({bigImage: hotAir})
                } else if (processName === "Electrical Test") {
                    this.setState({bigImage: electricalTest})
                } else if (processName === "Profiling") {
                    this.setState({bigImage: profiling})
                } else if (processName === "Final Inspection") {
                    this.setState({bigImage: finalInspection})
                }/*else if (processName==="Packaging,Delivery"){
            this.setState({bigImage:slide3})
        }*/ else {
                    this.setState({showImage: false})
                    console.log("NO preview")
                }
            });

    }

    showImage1(processName) {
        this.setState({showImage: true});
        if (processName === "MI") {
            this.setState({bigImage: slide2})
        } else if (processName === "Inner Layer") {
            this.setState({bigImage: slide3})
        } else if (processName === "Lamination") {
            this.setState({bigImage: slide4})
        } else if (processName === "Drilling") {
            this.setState({bigImage: slide5})
        } else if (processName === "Copper Deposition") {
            this.setState({bigImage: testj})
        } else if (processName === "Image the outer layers") {
            this.setState({bigImage: slide5})
        } else if (processName === "pattern Plating") {
            this.setState({bigImage: slide4})
        } else if (processName === "Automatic Optical Inspection(AOI)") {
            this.setState({bigImage: slide3})
        } else if (processName === "Solder Mask") {
            this.setState({bigImage: slide2})
        } else if (processName === "Silkscreen") {
            this.setState({bigImage: testj})
        } else if (processName === "HASL") {
            this.setState({bigImage: slide4})
        } else if (processName === "Electrical Test") {
            this.setState({bigImage: slide2})
        } else if (processName === "Profiling") {
            this.setState({bigImage: slide4})
        } else if (processName === "Final Inspection") {
            this.setState({bigImage: slide5})
        } else if (processName === "Packaging,Delivery") {
            this.setState({bigImage: slide3})
        } else {
            this.setState({bigImage: testj})
        }

    }

    hideImage() {
        this.setState({showImage: false})
    }

    setDimention3Value() {
        let pcbParams = this.props.orderItem.quotation.pcbParam;
        let stencilParams = this.props.orderItem.quotation.stencilParam;
        let dimensions = 0;
        if (this.props.orderItem.quotation.orderType === 1) {
            dimensions = pcbParams.width !== '' && pcbParams.length !== '' ?
                pcbParams.width + "x" + pcbParams.length + "" : '';
        }
        if (this.props.orderItem.quotation.orderType === 3) {
            let dimensionValue = stencilParams.dimensionsID;
            /*dimensions = dimensionValue === "380*280" ? "380*280(Valid area 290mm*190mm, $6.03, 0.8kg)" :
               dimensionValue === "100*100" ? "100*100(default dimension)" : "";*/
            dimensions = dimensionValue;
        }
        if (this.props.orderItem.quotation.orderType === 2) {
            let dimensionsPCB = pcbParams.width !== '' && pcbParams.length !== '' ?
                pcbParams.width + "x" + pcbParams.length + "" : '';
            // let dimensionsSMT = pcbParams.smtStencilParam.dimensionsID;

            // let dimensionsSMT = pcbParams.smtStencilParam.dimensionsID;
            dimensions = dimensionsPCB;
            // dimensions = "PCB:<br/>"+dimensionsPCB+"<br/>"+"SMT:<br/>"+dimensionsSMT;
        }
        return dimensions;
    }

    getOrderProductionStatus = () => {
        let axiosConfig = {
            headers: {
                'Content-Type': 'application/json;charset=UTF-8',
                "Access-Control-Allow-Origin": "*",
            }
        };

        axios.get(RESOURCE_BASE_URL + 'api/item/production/status/' + this.props.orderItem.orderUUID + '/' + this.props.orderNo, axiosConfig)
            .then((res) => {

                console.log("WipProcessLast ====> ", res.data.result.wipProcesses);

                this.setState({
                    productionStatus: res.data,
                    wipProcessList: res.data.result.wipProcesses
                });

                let technicsProcessName = this.state.wipProcessList[this.state.wipProcessList.length - 1]
                console.log("WipProcessLast ====> ", technicsProcessName.technicsProcessName);

                if (technicsProcessName.technicsProcessName !== 'shipped') {
                    axios.get(RESOURCE_BASE_URL + 'api/jlcpcb/order/production/status/' + this.props.orderItem.orderUUID + '/' + this.props.orderNo, axiosConfig)
                        .then((res) => {
                            console.log("orderItem getCall == >", res.data);

                            const jsonObject = [
                                {
                                    beginTime: "2020-09-27T23:40:08+08:00",
                                    technicsProcessName: "MI"
                                },
                                {
                                    beginTime: "2020-09-28T00:29:37+08:00",
                                    technicsProcessName: "Drilling"
                                },
                                {
                                    beginTime: "2020-09-28T03:14:55+08:00",
                                    technicsProcessName: "Copper Deposition"
                                },
                                {
                                    beginTime: "2020-09-28T03:35:50+08:00",
                                    technicsProcessName: "Image the outer layers"
                                },
                                {
                                    beginTime: "2020-09-28T05:15:19+08:00",
                                    technicsProcessName: "Pattern Plating"
                                },
                                {
                                    beginTime: "2020-09-28T15:12:04+08:00",
                                    technicsProcessName: "Automatic Optical Inspection(AOI)"
                                },
                                {
                                    beginTime: "2020-09-28T15:15:21+08:00",
                                    technicsProcessName: "Solder Mask"
                                },
                                {
                                    technicsProcessName: "Silkscreen"
                                },
                                {
                                    beginTime: "2020-09-28T22:28:56+08:00",
                                    technicsProcessName: "Hot Air Solder Leveling(HASL)"
                                },
                                {
                                    technicsProcessName: "Electrical Test"
                                },
                                {
                                    beginTime: "2020-09-29T05:54:22+08:00",
                                    technicsProcessName: "Profiling,V-cut scoring"
                                },
                                {
                                    beginTime: "2020-09-29T12:02:48+08:00",
                                    technicsProcessName: "Final inspection"
                                },
                                {
                                    beginTime: "2020-09-29T12:22:20+08:00",
                                    technicsProcessName: "Delivery"
                                }]

                            // if(res.data.result!==null){
                            this.setState({
                                productionStatus: res.data,
                                processList: res.data.result.wipProcesses,
                            });


                        })
                        .catch((err) => {
                            console.log("[API] ERROR: ", err);
                            axios.get(RESOURCE_BASE_URL + 'api/item/production/status/' + this.props.orderItem.orderUUID + '/' + this.props.orderNo, axiosConfig)
                                .then((res) => {
                                    console.log("orderItemUUID == > " + this.props.orderItem.orderUUID + " ====> " + this.props.orderNo);
                                    console.log("orderItem catchCall == >", res.data);
                                    this.setState({
                                        productionStatus: res.data,
                                        processList: res.data.result.wipProcesses
                                    });
                                })
                                .catch((err) => {
                                    console.log("[API] ERROR: ", err);
                                });

                        });
                } else {
                    console.log("WipProcessLast ====> ", technicsProcessName.technicsProcessName);
                    this.setState({
                        productionStatus: res.data,
                        processList: res.data.result.wipProcesses,
                        shipStatus: 'shipped'
                    });
                }

            })
            .catch((err) => {
                console.log("[API] ERROR: ", err);


            });
    };

    componentDidMount() {
        this.setState({size: this.setDimention3Value()});
        // this.getOrderProductionStatus();
        var collapsed = true;
        setTimeout(() => {

            $('.btnCollapse').children('.minus').hide()

            $(".btnCollapse").click(function () {
                collapsed = !collapsed;
                if (collapsed) {
                    $(this).children('.minus').hide()
                    $(this).children('.plus').show()
                    $(this).parent().parent().children('.collapseContent').slideUp('slow');
                } else {

                    $(this).children('.plus').hide()
                    $(this).children('.minus').show()
                    $(this).parent().parent().children('.collapseContent').slideDown('slow');
                }
            });
        }, 100)
    }

    handleClose = () => {
        this.setState({show: false});
    };

    handleShow = () => {
        this.setState({show: true});
    };

    handleShowProcess = () => {
        this.getOrderProductionStatus();
        this.setState({
            showProcess: true,
        });

    };

    handleCloseProcess = () => {
        this.setState({showProcess: false});
    };

    render() {
        // let beginNewTime = '';
        var newBeginDate = new Date();
        // newBeginDate.setHours(newBeginDate.getHours() - 1);
        let percentage = 0;

        let beginTime = "N/A";
        let endTime = "N/A";
        let technicsProcessName = "N/A";

        let pcbParams = this.props.orderItem.quotation.pcbParam;
        let stencilParams = this.props.orderItem.quotation.stencilParam;
        let typeDataPCB = {};
        let typeDataSMT = {};
        let dimensionsSMT = "N/A";

        if (this.props.orderItem.quotation.orderType === 1) {
            typeDataPCB = pcbParams;
        } else if (this.props.orderItem.quotation.orderType === 2) {
            typeDataPCB = pcbParams;
            typeDataSMT = stencilParams;
            dimensionsSMT = stencilParams.dimensionsID
        } else if (this.props.orderItem.quotation.orderType === 3) {
            dimensionsSMT = stencilParams.dimensionsID
        }

        dimensionValues.map((dimension) => {
            if (dimensionsSMT === dimension.id) {
                dimensionsSMT = dimension.value
            } else {
                dimensionsSMT = "N/A"
            }
        });

        let offset = new Date().getTimezoneOffset();

        // let dimensionsSMT = pcbParams.smtStencilParam.dimensionsID;

        // let dimensions = 0;
        let quantity = this.props.orderItem.quotation.orderType === 1 || this.props.orderItem.quotation.orderType === 2 ? pcbParams.qty : stencilParams.stencilQty;
        // console.log("ORDER ITEM DUO ====> ", this.props.orderItem);
        return (
            <div className="row header-highlight-border div-row7-div" id="div-row7-border">
                {/*<div className="row spacer"></div>*/}
                <div className="responsive-userAddress-table" id=" ">
                    <div className="col-md-5 no-margin img-data-div div-row7-row1" id="img-data-line">
                        <div className="row ">
                            <div className="row spacer"></div>
                            <div className="col-md-5 image-div">
                                <ImageView imagePath={this.props.orderItem.imageUrlFront}/>

                            </div>
                            <div className="col-md-7 testee no-padding-right">
                                <div className="order-history-details">
                                    <div className="pull-left text-justify">
                                        <FormattedMessage id="app.order.history.item.order-no"
                                                          defaultMessage="Order No"
                                                          description=""/>:
                                    </div>
                                    <div className="pull-right">
                                        <label>
                                            {this.props.orderItem.barcode}
                                        </label>
                                    </div>
                                </div>
                                <br/>


                                <div className="order-history-details">
                                    <div className="pull-left text-justify ordr-detail-heading">
                                        <FormattedMessage id="app.order.history.table-header.order-quantity"
                                                          defaultMessage="Quantity"
                                                          description=""/>:
                                    </div>
                                    <div className="row no-margin no-padding text-right">
                                    <span className="ordr-detail-lbl">
                                        {quantity}&nbsp;
                                        <FormattedMessage id="app.order.history.order-quantity.unit"
                                                          defaultMessage="sheets"
                                                          description=""/>
                                    </span>
                                    </div>
                                </div>
                                {/* <div className="order-history-details">
                                <div className="pull-left text-justify">
                                    <FormattedMessage id="app.order.history.table-header.order-quantity"
                                                                            defaultMessage="Quantity"
                                                                            description=""/>:
                                </div>
                                <div className="pull-right">
                                    <label>
                                        {pcbParams.qty}&nbsp;
                                        <FormattedMessage id="app.order.history.order-quantity.unit"
                                                          defaultMessage="sheets"
                                                          description=""/>
                                    </label>
                                </div>
                            </div>
                            <br/>*/}

                                <div className="">
                                    <ItemDetailsModal orderType={this.props.orderItem.quotation.orderType}
                                                      pcbParams={this.props.orderItem.pcbParams}
                                                      itemDetails={this.props.orderItem}
                                                      orderNo={this.props.orderNo}
                                    />
                                </div>

                                <div className="order-history-details">
                                    <div className="pull-left text-justify ordr-detail-heading">
                                        <FormattedMessage id="app.order.history.item.build-days"
                                                          defaultMessage="build time"
                                                          description=""/>:
                                    </div>
                                    <div className="pull-right">
                                        <span className="ordr-detail-lbl">
                                            {/*{this.props.build}*/}
                                            {this.props.orderItem.buildTime}
                                            &nbsp;
                                            {/*<FormattedMessage id="app.quotation.price-info.build-hours"*/}
                                            {/*                        defaultMessage="hours"*/}
                                            {/*                        description=""/>*/}
                                        </span>
                                    </div>
                                </div>
                                <br/>

                                {/*<FormattedMessage id="app.order.history.item.days"
                                              defaultMessage="days"
                                              description=""/>*/}

                            </div>

                        </div>


                    </div>
                    {/*<div className="col-md-2 dimension-order-div center-div-size div-row7-row2">*/}
                    {/*<div className="row spacer"></div>*/}
                    {/*/!*{this.props.orderItems.quotation.orderType === 1 &&*/}
                    {/*dimensions = pcbParams.width !== '' && pcbParams.length !== '' ?*/}
                    {/*pcbParams.width+"*"+pcbParams.length+"" : '';*/}
                    {/*}*!/*/}
                    {/*{this.props.orderItems.quotation.orderType === 1 &&*/}
                    {/*<b>{this.state.size}</b>*/}
                    {/*}*/}
                    {/*{this.props.orderItems.quotation.orderType === 3 &&*/}
                    {/*<b>{this.state.size}</b>*/}
                    {/*}*/}


                    {/*{this.props.orderItems.quotation.orderType === 2 &&*/}

                    {/*<div>*/}
                    {/*PCB :<br/> <b>  {this.state.size}</b><br/>*/}
                    {/*SMT :<br/> <b>{dimensionsSMT}</b>*/}
                    {/*</div>*/}

                    {/*}*/}

                    {/*</div>*/}
                    {/*<div className="col-md-2 no-margin dimension-order-div div-row7-row3 ">*/}
                    {/*<div className="row spacer"></div>*/}
                    {/*/!*{this.props.orderItems.quantity}*!/*/}
                    {/*{this.props.orderItems.quotation.orderType === 1 &&*/}
                    {/*<b>  {pcbParams.qty}</b>*/}
                    {/*}*/}
                    {/*{this.props.orderItems.quotation.orderType === 3 &&*/}
                    {/*<b>  {pcbParams.stencilQty}</b>*/}
                    {/*}*/}
                    {/*{this.props.orderItems.quotation.orderType === 2 &&*/}
                    {/*<div>*/}
                    {/*PCB : <br/><b>  {typeDataPCB.qty}</b><br/>*/}
                    {/*SMT :<br/> <b>{typeDataSMT.stencilQty}</b>*/}
                    {/*</div>*/}

                    {/*}*/}
                    {/*</div>*/}
                    <div className="col-md-4 no-padding float-div div-row7-row4">
                        <div className="row spacer"></div>
                        <FormattedMessage id="app.order.history.item.gerber-file"
                                          defaultMessage="Gerber File"
                                          description=""/>
                        <br/>
                        <label className="gerberFile-name">
                            {this.props.orderItem.itemName}
                        </label>
                        <br/>
                        <a className="btn track-btn no-padding" onClick={this.handleShowProcess}>
                        <span>
                            <FormattedMessage id="app.order.history.item.production-progress"
                                              defaultMessage="Production Progress"
                                              description=""/><br/>
                        </span>
                        </a>
                        {/*<div className="row spacer"></div>*/}
                        {this.props.showReorderComponents === true ?
                            <span>
                            <ReorderComponent orderType={this.props.orderItem.quotation.orderType}
                                              orderItem={this.props.orderItem}
                                              setReorderItems={this.props.setReorderItems}
                                              reorderParams={this.props.reorderParams}
                            />
                        </span>
                            : ""
                        }


                        {/* {this.props.productionProgress === 0 &&
                    <b>Cancel</b>
                    }
                    {this.props.productionProgress === 1 &&
                    <b>Pending Review</b>
                    }
                    {this.props.productionProgress === 2 &&
                    <b>Confirm</b>
                    }
                    {this.props.productionProgress === 3 &&
                    <b>Ordered</b>
                    }
                    {this.props.productionProgress === 4 &&
                    <b>In Production</b>
                    }
                    {this.props.productionProgress === 5 &&
                    <b>Shipped</b>
                    }*/}
                        <b>

                            {/*{this.props.statusCode}*/}
                            {/*{this.props.status}*/}
                            {/*{beginTime}<br/>{endTime}*/}
                        </b><br/>

                        {this.props.status === 'SHIPPED' || this.props.status === "出荷済み" ?
                            <QualityComplaints orderItem={this.props.orderItem} details={this.props}
                                               email={this.props.email}/>
                            : ""
                        }

                    </div>
                </div>


                <div className="responsive-userAddress-table-mobile set-padding-responsive-profile" id=" ">
                    <div className="">
                        <div className="padding-img-mobile">
                            <div className="custom-col-4 align-img-responsive">
                                {/*<ImageViewMobile imagePath={this.props.orderItem.imageUrlFront}/>*/}
                                <img className="cart-item-preview-image-mobile"
                                     src={this.props.orderItem.imageUrlFrontEncoded}
                                     alt=""/>
                            </div>

                            <div className="custom-col-8 resp-order-item-details">
                                <div className="">
                                    <div className="custom-col-5">
                                        <FormattedMessage id="app.order.history.item.order-no"
                                                          defaultMessage="Order No"
                                                          description=""/>:
                                    </div>
                                    <div className="custom-col-7">
                                        {this.props.orderItem.barcode}
                                    </div>
                                </div>
                                <div className="">
                                    <div className="custom-col-5">
                                        <FormattedMessage id="app.order.history.table-header.order-quantity"
                                                          defaultMessage="Quantity"
                                                          description=""/>:
                                    </div>
                                    <div className="custom-col-7">
                                        {quantity}
                                        <FormattedMessage id="app.order.history.order-quantity.unit"
                                                          defaultMessage="sheets"
                                                          description=""/>
                                    </div>
                                </div>

                                <div className="">
                                    <ItemDetailsModal orderType={this.props.orderItem.quotation.orderType}
                                                      pcbParams={this.props.orderItem.pcbParams}
                                                      itemDetails={this.props.orderItem}
                                                      orderNo={this.props.orderNo}
                                    />
                                </div>
                                <div className="">
                                    <div className="custom-col-5">
                                        <FormattedMessage id="app.order.history.item.build-days"
                                                          defaultMessage="build time"
                                                          description=""/>:
                                    </div>
                                    <div className="custom-col-7">
                                        <label>
                                            {this.props.orderItem.buildTime}
                                        </label>
                                    </div>
                                </div>
                                <br/>
                            </div>

                        </div>


                    </div>

                    <div>
                        <div className="title-background2-responsive">
                            <div className='custom-col-4'></div>
                            <div className="custom-col-6 text-align-cus-order-item">
                                <FormattedMessage id="app.order.history.table-header.order-file"
                                                  defaultMessage="Product File"
                                                  description=""/>

                            </div>
                            <div className="custom-col-1 float-right-plus btnCollapse">
                                <span className="plus"><img src={canvasDown} alt="" width='25px'/></span>
                                <span className="minus"><img src={canvasUp} alt="" width='25px'/></span>
                            </div>
                            <div className="custom-col-1"></div>
                        </div>

                        <div className="collapseContent set-padding-collapse-content-order-item">
                            <FormattedMessage id="app.order.history.item.gerber-file"
                                              defaultMessage="Gerber File"
                                              description=""/>
                            <br/>
                            <label className="gerberFile-name">
                                {this.props.orderItem.itemName}
                            </label>
                            <br/>
                            <a className="" onClick={this.handleShowProcess}>
                        <span>
                            <FormattedMessage id="app.order.history.item.production-progress"
                                              defaultMessage="Production Progress"
                                              description=""/><br/>
                        </span>
                            </a>
                            {this.props.showReorderComponents === true ?
                                <span>
                            <ReorderComponent orderType={this.props.orderItem.quotation.orderType}
                                              orderItem={this.props.orderItem}
                                              setReorderItems={this.props.setReorderItems}
                                              reorderParams={this.props.reorderParams}
                            />
                        </span>
                                : ""
                            }

                            <br/>

                            {this.props.status === 'SHIPPED' || this.props.status === "出荷済み" ?
                                <QualityComplaints orderItem={this.props.orderItem} details={this.props}
                                                   email={this.props.email}/>
                                : ""
                            }

                        </div>
                    </div>
                </div>


                <div className="order-model-mobile">

                    <Modal show={this.state.showProcess} onHide={this.handleCloseProcess}
                           dialogClassName="your-dialog-classname order-item-model-div-margin order-item-progress-resp">
                        <Modal.Header closeButton>
                            <div className="title-1 color-text">
                                {/*プロセス*/}
                                進捗状況
                            </div>
                        </Modal.Header>
                        <Modal.Body>
                            <div className=" row color-text">

                                {/** uncomment this for order progress-------------------------*/}

                                {/*{console.log("processList",this.state.processList)}*/}
                                <div className="col-md-3 custom-col-12">
                                    {this.state.processList !== null && this.state.processList !== undefined && this.state.processList.length !== 0 &&
                                    <div>
                                        {this.state.processList.map(processItem => {
                                            let processPercentage = 0;
                                            let today = moment(new Date());

                                            if (processItem.beginTime !== null) {
                                                processPercentage = 100
                                            }

                                            percentage = percentage + processPercentage;
                                            console.log("percentage status ====> " + percentage);

                                        })}
                                    </div>
                                    }
                                    {this.state.processList !== null && this.state.processList !== undefined && this.state.processList.length !== 0 &&
                                    <div id="circularProgressbar-div">
                                        {this.state.shipStatus === 'shipped' ?
                                            <CircularProgressbar
                                                value={100}
                                                text={`100%`}
                                                className="orderItem-100-img"
                                                styles={buildStyles({
                                                    pathColor: '#f29c21',
                                                    textColor: '#f29c21',
                                                })}/> :
                                            <CircularProgressbar
                                                value={Math.round((percentage-50) / this.state.processList.length)}
                                                text={`${Math.round((percentage-50) / this.state.processList.length)}%`}
                                                className="orderItem-100-img"
                                                styles={buildStyles({
                                                    pathColor: '#f29c21',
                                                    textColor: '#f29c21',
                                                })}/>
                                        }
                                    </div>
                                    }
                                    <div className="mobile-br-tag"></div>
                                </div>
                                <div className="col-md-9 remove-left-padding-order-item-model">
                                    {/*<video className="prgrss-img middle-img-prod" autoPlay>
                                    <source src={this.state.bigImage} type="video/mp4"/>
                                </video>*/}
                                    {/*<img className="prgrss-img middle-img-prod" src={this.state.bigImage} alt=""/>*/}
                                    {this.state.showImage === true &&
                                    <video className="prgrss-img middle-img-prod" autoPlay>
                                        <source src={this.state.bigImage} type="video/mp4"/>
                                    </video>

                                    }
                                    <ol>
                                        {this.state.processList !== null && this.state.processList !== undefined && this.state.processList.length !== 0 &&
                                        <div>
                                            {/*{this.state.showImage===true &&
                                        <span className="over1">
                                                <img  src={testj} alt=""/>
                                        </span>
                                        }*/}
                                            {this.state.processList.map(processItem => {

                                                let localDate1 = (moment(processItem.beginTime).add(-offset / 60, 'h').toJSON());
                                                // let timeDuration = moment.duration("00.01.00");

                                                return <div className="row">
                                                    <li>
                                                        <div
                                                            className="col-md-5 custom-col-5 remove-padding-orderItem-model">
                                                            {processItem.technicsProcessName === "MI" ?
                                                                <text>材料投入</text> :
                                                                processItem.technicsProcessName === "Inner Layer" ?
                                                                    <text>積層</text> :
                                                                    processItem.technicsProcessName === "Print" ?
                                                                        <text>最終印刷</text> :
                                                                        processItem.technicsProcessName === "Lamination" ?
                                                                            <text>ラミネート</text> :
                                                                            processItem.technicsProcessName === "Delivery" ?
                                                                                <text>出荷準備中</text> :
                                                                                processItem.technicsProcessName === "Shipping to Hong Kong transit point" ?
                                                                                    <text>香港中継点へ出荷</text> :
                                                                                    processItem.technicsProcessName === "Arrive at Hong Kong transit point" ?
                                                                                        <text>香港中継点に到着</text> :
                                                                                        processItem.technicsProcessName === "Drilling" ?
                                                                                            <text>穴あけ</text> :
                                                                                            processItem.technicsProcessName === "Copper Deposition" ?
                                                                                                <text>化学メッキ</text> :
                                                                                                processItem.technicsProcessName === "Image the outer layers" ?
                                                                                                    <text>露光・現像</text> :
                                                                                                    processItem.technicsProcessName === "Pattern Plating" ?
                                                                                                        <text>回路形成</text> :
                                                                                                        processItem.technicsProcessName === "Automatic Optical Inspection(AOI)" ?
                                                                                                            <text>中間検査</text> :
                                                                                                            processItem.technicsProcessName === "Automatic Visual Inspection" ?
                                                                                                                <text>外観検査</text> :
                                                                                                                processItem.technicsProcessName === "Solder Mask" ?
                                                                                                                    <text>レジスト印刷</text> :
                                                                                                                    processItem.technicsProcessName === "Silkscreen" ?
                                                                                                                        <text>シルク印刷</text> :
                                                                                                                        processItem.technicsProcessName === "Hot Air Solder Leveling(HASL)" ?
                                                                                                                            <text>表面処理</text> :
                                                                                                                            processItem.technicsProcessName === "Electrical Test" ?
                                                                                                                                <text>導通検査</text> :
                                                                                                                                processItem.technicsProcessName === "Profiling,V-cut scoring" ?
                                                                                                                                    <text>外形加工・Vカット</text> :
                                                                                                                                    processItem.technicsProcessName === "Final inspection" ?
                                                                                                                                        <text>最終検査</text> :
                                                                                                                                        processItem.technicsProcessName === "Package" ?
                                                                                                                                            <text>梱包</text> :
                                                                                                                                            processItem.technicsProcessName === "shipped" ?
                                                                                                                                                <text>出荷完了</text> :
                                                                                                                                                <text>{processItem.technicsProcessName}</text>


                                                            }
                                                        </div>
                                                        {window.innerWidth > 992 ?
                                                            <span className="">
                                                                {processItem.beginTime !== null ?
                                                                    <div
                                                                        className="col-md-7  custom-col-7 font-size-order-item-mobile left-padding-order-item-mobile order-item-video-playing">
                                                                        <img
                                                                            onMouseOver={() => this.showImage(processItem.technicsProcessName)}
                                                                            onMouseOut={this.hideImage}
                                                                            className="prgrss-img" src={progress} alt=""
                                                                            id="arrow-img"

                                                                        />
                                                                        <span
                                                                            className="nbsp-web">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>

                                                                        {localDate1.substring(0, 10)} {localDate1.substring(11, 19)}

                                                                    </div> :
                                                                    <div
                                                                        className="col-md-7  custom-col-7 font-size-order-item-mobile left-padding-order-item-mobile">
                                                                        <img className="prgrss-img" src={noProgress}
                                                                             alt=""/>
                                                                    </div>
                                                                }
                                                            </span>
                                                            :
                                                            <span className="">
                                                                {processItem.beginTime !== null ?
                                                                    <div
                                                                        className="col-md-7  custom-col-7 font-size-order-item-mobile left-padding-order-item-mobile order-item-video-playing">
                                                                        <img
                                                                            onMouseDown={() => this.showImage(processItem.technicsProcessName)}
                                                                            onMouseOutCapture={this.hideImage}
                                                                            className="prgrss-img" src={progress} alt=""
                                                                            id="arrow-img"

                                                                        />
                                                                        <span
                                                                            className="nbsp-web">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>

                                                                        {localDate1.substring(0, 10)} {localDate1.substring(11, 19)}

                                                                    </div> :
                                                                    <div
                                                                        className="col-md-7  custom-col-7 font-size-order-item-mobile left-padding-order-item-mobile">
                                                                        <img className="prgrss-img" src={noProgress}
                                                                             alt=""/>
                                                                    </div>
                                                                }
                                                            </span>

                                                        }
                                                        {/*<div>*/}
                                                        {/*{processItem.beginTime !== null ?*/}
                                                        {/*<div className="col-md-7  custom-col-7 font-size-order-item-mobile left-padding-order-item-mobile order-item-video-playing">*/}
                                                        {/*<img*/}
                                                        {/*onMouseOver={() => this.showImage(processItem.technicsProcessName)}*/}
                                                        {/*onMouseOut={this.hideImage}*/}
                                                        {/*className="prgrss-img" src={progress} alt=""*/}
                                                        {/*id="arrow-img"*/}

                                                        {/*/>*/}
                                                        {/*<span className="nbsp-web">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>*/}
                                                        {/*/!*<span className="nbsp-mobile"></span>*!/*/}
                                                        {/*/!*{console.log("timeeeeeeee2323",(moment(processItem.beginTime).add(-offset/60,'h')))}*!/*/}

                                                        {/*{localDate1.substring(0, 10)} {localDate1.substring(11, 19)}*/}

                                                        {/*</div> :*/}
                                                        {/*<div*/}
                                                        {/*className="col-md-7  custom-col-7 font-size-order-item-mobile left-padding-order-item-mobile">*/}
                                                        {/*<img className="prgrss-img" src={noProgress} alt=""/>*/}
                                                        {/*</div>*/}
                                                        {/*}*/}
                                                        {/*</div>*/}

                                                    </li>
                                                </div>
                                            })}

                                        </div>
                                        }
                                        {/* {this.state.processList===null || this.state.processList===undefined || this.state.processList.length===0 &&
                                    <div><span className="col-md-9">
                                            現時点で表示する生産進捗データはありません。
                                        </span>
                                        <span className="col-md-3"></span>
                                    </div>
                                    }*/}


                                    </ol>

                                </div>
                                {/** -------------------------------------------------------*/}
                                {this.state.processList === null || this.state.processList === undefined || this.state.processList.length === 0 &&
                                <div><span className="col-md-9">
                                            現時点で表示する生産進捗データはありません。
                                        </span>
                                    <span className="col-md-3"></span>
                                </div>
                                }
                            </div>

                        </Modal.Body>
                        <Modal.Footer>
                            <div className="col-md-offset-2 pull-right color-text">
                                <button className="btn btn-info' bottom-button" onClick={this.handleCloseProcess}>
                                    <FormattedMessage id="app.admin.change.status.close"
                                                      defaultMessage="Close "
                                                      description=""/>
                                </button>
                            </div>
                        </Modal.Footer>
                    </Modal>
                </div>
                {/* <Modal show={this.state.showImage} dialogClassName="img-product-modal" id="img-prod-modal">

                    <Modal.Body>
                        <img className="prgrss-img" src={testj} alt="" id="real-img"/>
                    </Modal.Body>
                </Modal>*/}
            </div>

        );
    }

}

export default OrderItem;



// WEBPACK FOOTER //
// ./src/components/Site/Order/OrderHistory/OrderItem/OrderItem.js